module.exports = __webpack_public_path__ + "img/xunjian.6c9e4cd0.jpg";